const Igape = () => {

    return (
        <main className="flex col acenterv vw70 pad-10 gap-10">

            <h1>PROXECTO COFINANCIADO POR IGAPE, XUNTA DE GALICIA E FONDO EUROPEO DE DESENVOLVEMENTO REXIONAL DO PROGRAMA OPERATIVO 2014-2020</h1>
            <img src="/images/Cartel-web-Dixitalizacion-2021.webp" alt="Cartel de ayudas de 'Igape'" />
            
        </main>
    )
}

export default Igape
